import {AppClassProperties, AppProps, UIAppState} from "../types";
import {ExcalidrawElement} from "../element/types";
import {ActionManager} from "../actions/manager";
import style from "./ActionToolbar.module.scss"
import {
    generateUUID2,
    getImagePathWithTheme,
    imgPathPerfix,
    isDarkMode,
    isFileElement,
    isFileVideoElement, isSupportVideoAnnoUrl
} from "../../../../src/utils";
import i18next, {t} from "i18next";
import {List, Popover, Tooltip} from "antd";
import {
    COLOR_E5E5E5,
    COLOR_TRANSPARENT,
    DRAW_TOOL_POPOVER_TOP,
    ELEMENT_POPOVER_TOOLS_OFFSET_Y,
    EVENT_BACKGROUND_COLOR_CHANGE,
    EVENT_ELEMENT_DELETE,
    EVENT_FONT_STROKE_COLOR_CHANGE,
    EVENT_FORCE_UPDATE_TOOLBAR_MENU,
    EVENT_KEY_ESCAPSE,
    EVENT_NOTE_CHANGED,
    EVENT_STICKYNOTE_SELECTION_CHANGE,
    EVENT_STROKE_COLOR_CHANGE,
    EVENT_TOOLBAR_LOCKED_CHANGED,
    HAS_ENABLE_TIPTAP_TEXT,
    KEY_GLOBAL_YOUTUBE_EMBED_MODE,
    KEY_STICKYNOTES_HAS_BORDER,
    KEY_TEXT_HAS_BORDER
} from "../../../../src/Const";
import React, {useContext, useEffect, useLayoutEffect, useReducer, useState} from "react";
import {getSelectedElements, getTargetElements} from "../scene";
import {ROUNDNESS} from "../constants";
import {getNonDeletedElements, isTextElement} from "../element";
import {
    hasBoundTextElement, isArrowElement, isBoundElementText,
    isFreeDrawElement,
    isMindmapElement, isShapeElement,
    isStickyNotesElement,
    isTextOrBoundElement
} from "../element/typeChecks";
import {getBoundTextElement} from "../element/textElement";
import {getFormValue} from "../actions/actionProperties";
import {postMessage, recvMessage, unSubscribe} from "../../../../src/common/event";
import {mutateElement} from "../element/mutateElement";
import {isMac} from "../../../../src/Utility";
import Global from "../../../../src/global";

export const useApp0 = () => useContext(AppContext);

export const ActionToolbar_Menu = ({
                                  appState,
                                  elements,
                                    app,
                                  renderAction,
                              }: {
    appState: UIAppState;
    elements: readonly ExcalidrawElement[];
    app:AppClassProperties,
    renderAction: ActionManager["renderAction"];
}) =>{
    const [isShapePopover,setIsShapePopover] = useState(false);
    const [isLineStylePopover,setIsLineStylePopover] = useState(false);
    const [isAlignPopover,setIsAlignPopover] = useState(false);
    const [isLineSpacePopover,setIsLineSpacePopover] = useState(false);
    const [isFontColorPopover,setIsFontColorPopover] = useState(false);
    const [isTextStylePopover,setIsTextStylePopover] = useState(false);
    const [isStrokeColorPopover,setIsStrokeColorPopover] = useState(false);
    const [isDrawingPopover,setIsDrawingPopover] = useState(false);
    const [isBackgroundPopover,setIsBackgroundPopover] = useState(false);
    const [isPositionPopover,setIsPositionPopover] = useState(false);
    const [stickyNotesSelectionLength,setStickyNotesSelectionLength] = useState(0);
    const [randomTextBorderKey,setRandomTextBorderKey] = useState(generateUUID2());

    const ARRAY_SHAPE_ELEMENT = [
        {
            id: 'rectangle',
            key: 'rectangle',
            imageName: 'element_shape_jx_no_corner_1.png',
            title: t('Rectangle'),
            isActive: false
        },
        {
            id: 'roundedRectangle',
            key: 'roundedRectangle',
            imageName: 'element_shape_jx_1.png',
            title: t('Rectangle'),
            isActive: false
        },
        {
            id: 'diamond',
            key: 'diamond',
            imageName: 'element_shape_lx_1.png',
            title: t('Diamond'),
            isActive: false
        },
        {
            id: 'ellipse',
            key: 'ellipse',
            imageName: 'element_shape_ty_1.png',
            title: t('Ellipse'),
            isActive: false
        },
        {
            id: 'triangle',
            key: 'triangle',
            imageName: 'element_shape_sanjiaoxing_1.png',
            title: t('Line'),
            isActive: false
        },
        {
            id: 'bubble',
            key: 'bubble',
            imageName: 'element_shape_chat_1.png',
            title: t('Line'),
            isActive: false
        },
        {
            id: 'pentagram',
            key: 'pentagram',
            imageName: 'element_shape_star_1.png',
            title: t('Line'),
            isActive: false
        },
        {
            id: 'parallelogram',
            key: 'parallelogram',
            imageName: 'element_shape_pingxingsibianxing_1.png',
            title: t('Line'),
            isActive: false
        },
        {
            id: 'thickArrow',
            key: 'thickArrow',
            imageName: 'element_shape_way_1.png',
            title: t('Line'),
            isActive: false
        },
        {
            id: 'null',
            key: 'null',
            imageName: 'null.png',
            title: t('null'),
            isActive: false
        }
    ];

    function onKeydownListener(){
        if (isShapePopover){
            setIsShapePopover(false);
        }
        if (isLineStylePopover){
            setIsLineStylePopover(false);
        }
        if (isAlignPopover){
            setIsAlignPopover(false);
        }
        if (isFontColorPopover){
            setIsFontColorPopover(false);
        }
        if (isStrokeColorPopover){
            setIsStrokeColorPopover(false);
        }
        if (isDrawingPopover){
            setIsDrawingPopover(false);
        }
        if (isBackgroundPopover){
            setIsBackgroundPopover(false);
        }
        if (isPositionPopover){
            setIsPositionPopover(false);
        }
    }

    useEffect(()=>{
        recvMessage(EVENT_KEY_ESCAPSE,(msg,data)=>{
            console.log("EVENT_KEY_ESCAPSE")
            onKeydownListener();
        });

        recvMessage(EVENT_STROKE_COLOR_CHANGE,(msg,data)=>{
            setStrokeColor(data.data.strokeColor);
        });

        recvMessage(EVENT_BACKGROUND_COLOR_CHANGE,(msg,data)=>{
            setBackgroundColor(data.data.backgroundColor);
        });

        recvMessage(EVENT_FONT_STROKE_COLOR_CHANGE,(msg,data)=>{
            setFontStrokeColor(data.data.fontStrokeColor);
        });

        // console.log("toolbar  uselayouteffect ")
        // document.body.addEventListener('keydown',onKeydownListener);
        // return ()=>{
        //     console.log("toolbar  uselayouteffect return")
        //     document.body.removeEventListener('keydown',onKeydownListener)
        // }

        return ()=>{
            unSubscribe(EVENT_KEY_ESCAPSE);
            unSubscribe(EVENT_STROKE_COLOR_CHANGE);
            unSubscribe(EVENT_BACKGROUND_COLOR_CHANGE);
            unSubscribe(EVENT_FONT_STROKE_COLOR_CHANGE);
        }
    })

    useEffect(()=>{
        recvMessage(EVENT_STICKYNOTE_SELECTION_CHANGE,(msg,data)=>{
            setStickyNotesSelectionLength(data.data.range?.length > 0);
        })
        return () => {
            unSubscribe(EVENT_STICKYNOTE_SELECTION_CHANGE)
        };
    },[elements])


    const targetElements = getTargetElements(
        getNonDeletedElements(elements),
        appState,
    );

    const targetSelectedElements = getSelectedElements(elements,appState,{includeBoundTextElement:false});

    let isSingleElementBoundContainer = false;
    if (
        targetElements.length === 2 &&
        (hasBoundTextElement(targetElements[0]) ||
            hasBoundTextElement(targetElements[1]))
    ) {
        isSingleElementBoundContainer = true;
    }

    const targetElementIsAllFreedraw = ()=>{
        return targetElements.length == targetElements.filter(p=>isFreeDrawElement(p)).length;
    }

    const targetElementIsAllText = ()=>{
        return targetElements.length == targetElements.filter(p=>isTextElement(p)).length;
    }

    const targetMindmapNode = appState.mindmap.selected.node;
    const isMindMap =()=>{
        return targetElements.some(element=>element.type == 'mindmap');
    }

    /**
     * 获取文本对齐图片名称
     */
    const getTextAlignImg = ()=>{
        return getFormValue(elements, appState,
            (element) => {
                if (isTextElement(element)) {
                    if (element.textAlign == 'left') {
                        return 'tool_align_text_left'
                    } else if (element.textAlign == 'center') {
                        return 'tool_align_text_center'
                    }
                    return 'tool_align_text_right';
                }
                const boundTextElement = getBoundTextElement(element);
                if (boundTextElement) {
                    if (boundTextElement.textAlign == 'left') {
                        return 'tool_align_text_left'
                    } else if (boundTextElement.textAlign == 'center') {
                        return 'tool_align_text_center'
                    }
                    return 'tool_align_text_right';
                }
                return 'tool_align_text_center'
            },
            (element) =>
                isTextElement(element) || getBoundTextElement(element) !== null,
            (hasSelection) =>
                'tool_align_text_center'
        )
    }

    /**
     * 文字的颜色
     */
    const getFontTextColor = ()=>{
        return getFormValue(elements, appState,
            (element) => {
                if (isTextElement(element)) {
                    return element.strokeColor;
                }
                const boundTextElement = getBoundTextElement(element);
                if (boundTextElement) {
                    return boundTextElement.strokeColor;
                }
                return 'linear-gradient( 90deg, #FF0000 0%, #FC9700 20%, #FFE500 39%, #14FF00 55%, #00FFFF 69%, #3300FF 85%, #EB00FF 100%)'
            },
            (element) =>
                isTextElement(element) || getBoundTextElement(element) !== null,
            (hasSelection) =>
                'linear-gradient( 90deg, #FF0000 0%, #FC9700 20%, #FFE500 39%, #14FF00 55%, #00FFFF 69%, #3300FF 85%, #EB00FF 100%)'
        )
    }
    const [fontStrokeColor,setFontStrokeColor] = useState(getFontTextColor);

    /**
     * 边框颜色
     */
    const getStrokColor = ()=>{
        try{
            let szStrokeColor = getFormValue(elements,appState,
                (element) =>element.strokeColor,
                true,
                appState.activeTool.type === 'highlighter'?appState.currentItemHighlightStrokeColor:appState.currentItemStrokeColor);
            if (!szStrokeColor){
                return '#000000'
            }
            if (szStrokeColor.toLowerCase() == 'transparent' || szStrokeColor.toLowerCase() == '#2c2c2c'){
                szStrokeColor = '#000000';
            }
            return szStrokeColor;
        }catch (e){
            return "#000000";
        }
    }
    const [strokeColor,setStrokeColor] = useState(getStrokColor());

    /**
     * free的颜色
     */
    const getFreedrawStrokeColor = ()=>{
        let szStrokeColor = getFormValue(elements,appState,
            (element) =>element.strokeColor,
            true,
            appState.activeTool.type === 'highlighter'?appState.currentItemHighlightStrokeColor:appState.currentItemDrawStrokeColor);

        return szStrokeColor;
    }

    /**
     * 背景颜色
     */
    const getBackgroundColor = ()=>{
        return getFormValue(elements,appState,
            (element) =>element.backgroundColor,
            true,
            appState.currentItemBackgroundColor);
    }
    const [backgroundColor,setBackgroundColor] = useState(getBackgroundColor());

    /**
     * 元素是否锁定
     */
    const getElementLockImage = ()=>{
        const arrayElements = getSelectedElements(elements,appState);
        if (arrayElements.length > 0){
            const element = arrayElements[0];
            if (element.locked){
                return 'toolbar_locked_element';
            }
            return 'toolbar_lock';
        }
        return 'toolbar_lock';
    }

    /**
     * 第一个选中的元素
     */
    const getFirstSelectElment = ()=>{
        const arrayElements = getSelectedElements(elements,appState);
        if (arrayElements.length > 0){
            return arrayElements[0];
        }
        return null;
    }

    const isBackgroundTransparent = ()=>{
        const szHex = backgroundColor.toLowerCase();
        return szHex == 'transparent' || szHex == '#ffffff' || szHex == 'white' || szHex == '#2c2c2c';
    }

    /**
     * position在第一个位置
     */
    const hasPositionInFirst = ()=>{
        return targetElements.length == 1 &&
            (targetElements.some(p=>isFileVideoElement(p) || isMindmapElement(p) || (p.type == "image" && !p.extra?.svg)) || targetMindmapNode);
    }

    /**
     * 线条样式后是否有坚分隔线
     */
    const hasStyleAfterVLine = ()=>{
        const hasPosition = targetElements.some(p=>(isFileVideoElement(p) || isMindmapElement(p) || (p.type == "image" && !p.extra?.svg)));
        const hasTextAndStrokeStyle = targetElements.some(p=>isTextElement(p) || (hasStrokeStyle(p) && !hasPosition)) && !targetElementIsAllFreedraw() && !targetElementIsAllText();
        return targetElements.some(p=>p.type == 'image') || (targetElements.length > 1 && ((!targetElementIsAllFreedraw() && !targetElementIsAllText() && !hasPosition) || hasTextAndStrokeStyle) && targetElements.some(p=>hasStrokeColor(p)));
    }

    /**
     * 背景色的颜色或背景
     */
    const renderBackgroundColor = ()=>{
        // if (isBackgroundTransparent()){
        //     return (
        //         <img className='img-30' style={{flexShrink:'0',width:'32px',height:'32px'}} src={imgPathPerfix() + 'toolbar_element_background_new.png'}/>
        //     )
        // }else{
        //     return (
        //         <div style={{background: backgroundColor,width:'22px',height:'22px', borderRadius: '5px', margin: '5px',flexShrink:'0'}}></div>
        //     )
        // }
        return (
            <img className='img-28 hovered renderbackgroundcolor' style={{flexShrink:'0',width:'30px',height:'30px'}} src={getImagePathWithTheme('toolbar_element_background_new')}/>
        )
    }

    /**
     * 是否可以切换形状
     * @param element
     */
    const hasChangeShape = (element:any)=>{
        return ARRAY_SHAPE_ELEMENT.filter(p=>p.id == element.type).length > 0;
    }

    /**
     * 是否有背景
     * @param element
     */
    const hasBackgroundColor = (element:any)=>{
        if (isFileElement(element))return false;

        return element.type === 'rectangle'
        || element.type === 'roundedRectangle'
        || element.type === 'diamond'
        || element.type === 'ellipse'
        || element.type === 'triangle'
        || element.type === 'bubble'
        || element.type === "parallelogram"
        || element.type === "pentagram"
        || element.type === "thickArrow"
        || element.type == 'iframe'
        || element.type == 'frame'
            // || (element.type == 'embeddable' && !isSupportVideoAnnoUrl(element.link) && element.embedType == 'text')
            || element.type == 'projectLink';
    }

    /**
     * 是否有边框色
     * @param element
     */
    const hasStrokeColor = (element:any)=>{
        if (isFileElement(element))return false;

        return (element.type === 'rectangle'
            || element.type === 'roundedRectangle'
            || element.type === 'diamond'
            || element.type === 'ellipse'
            || element.type === 'arrow'
            || element.type === 'line'
            || element.type === 'triangle'
            || element.type === 'bubble'
            || element.type === "parallelogram"
            || element.type === "pentagram"
            || element.type === "thickArrow"
            || element.type == 'iframe'
            // || element.type == 'embeddable'
            || element.type == 'freedraw'
            || element.type == 'highlighter'
            || element.type == 'frame'
            || (element.type == 'image' /*&& element?.extra?.svg*/)
        )
    }

    const isBookmarkElement = (element:any)=> {
        return (element.type == 'embeddable' && !isSupportVideoAnnoUrl(element.link) && element.embedType == 'text')
    }

    /**
     * 边框样式...
     * @param element
     */
    const hasStrokeStyle = (element:any)=>{
        if (isFileElement(element))return false;

        return (element.type === 'rectangle'
        || element.type === 'roundedRectangle'
        || element.type === 'diamond'
        || element.type === 'ellipse'
        || element.type === 'arrow'
        || element.type === 'line'
        || element.type === 'triangle'
        || element.type === 'bubble'
        || element.type === "parallelogram"
        || element.type === "pentagram"
        || element.type === "thickArrow"
        || element.type == 'iframe'
        // || element.type == 'embeddable'
        || element.type == 'freedraw'
        || element.type == 'highlighter'
            || element.type == 'image'
        )
    }

    let commonSelectedType: any | null =
        targetElements[0]?.type || null;

    /**
     * 当前激活的是绘制工具
     */
    const isActiveToolDrawing = ()=>{
        return (appState.activeTool.type == 'freedraw' || appState.activeTool.type == 'highlighter' || appState.activeTool.type == 'eraser')
    }

    return(

        <div className={style.toolbar + ' font-size-12'}>
            {
                //shape
                targetElements.some((element) => hasChangeShape(element)) &&
                <Popover trigger={"click"} placement={"bottom"}
                         arrow={false}
                         align={{offset: [0, ELEMENT_POPOVER_TOOLS_OFFSET_Y]}}
                         open={isShapePopover}
                         onOpenChange={(e) => setIsShapePopover(e)}
                         content={
                             <div style={{
                                 margin: '-12px',
                                 width: '156px',
                                 height: '80px',
                                 padding: '8px',
                                 display: 'flex',
                                 flexWrap: 'wrap',
                                 justifyContent: 'space-between',
                                 boxShadow: 'var(--dialog-box-shadow)',
                                 borderRadius: '8px'
                             }}>
                                 {
                                     ARRAY_SHAPE_ELEMENT.map(item => (
                                         <div key={item.id} className='flex-center hovered'
                                              style={{visibility: (item.id == 'null') ? 'hidden' : 'visible'}}>
                                             <img key={item.id}
                                                  className={isDarkMode() ? 'filter-img-white' : 'none'}
                                                  style={{width: '20px', height: '20px', margin: '6px 4px'}}
                                                  data-id={item.id}
                                                  onClick={(e) => {
                                                      const arraySelectedElements = getSelectedElements(elements, appState);
                                                      if (arraySelectedElements) {
                                                          //替换这个element...
                                                          let element0 = arraySelectedElements[0];
                                                          let roundness = null;
                                                          if (e.currentTarget.dataset.id == 'roundedRectangle') {
                                                              roundness = {
                                                                  type: ROUNDNESS.ADAPTIVE_RADIUS
                                                              };
                                                          }
                                                          let newElement = {
                                                              ...element0,
                                                              type: e.currentTarget.dataset.id,
                                                              roundness: roundness
                                                          }

                                                          var arrayNewElements = [...elements];
                                                          for (let i = 0; i < arrayNewElements.length; i++) {
                                                              if (arrayNewElements[i].id == element0.id) {
                                                                  arrayNewElements.splice(i, 1, newElement);
                                                              }
                                                          }
                                                          app.scene.replaceAllElements(arrayNewElements);
                                                      }
                                                  }}
                                                  src={imgPathPerfix() + item.imageName}/>
                                         </div>
                                     ))
                                 }
                             </div>
                         }>
                    <div className='flex-row-vertical-center'>
                        <div className={style.toolbarItem + ' flex-center'} style={{
                            width: '76px',
                            height: '30px',
                            borderRadius: '8px',
                            background: isShapePopover ? COLOR_E5E5E5() : 'transparent'
                        }}>
                            <img className='img-24' style={{marginTop:'-2px'}} src={getImagePathWithTheme('toolbar_shape')}/>
                            <span className='ml-2' >{t("Shape")}</span>
                        </div>
                        <div className={'line-split-width1'}></div>
                    </div>

                </Popover>
            }

            {
                //背景----**************背景当stroke使用.....分不清...
                targetElements.some((element) => hasBackgroundColor(element) || (element.type=='arrow' || element.type == 'line' || element.type == 'freedraw' || element.type == 'highlighter')) &&
                targetElements.some((element)=>element.customData?.generationData?.type != 'pdfAnno' && element.customData?.generationData?.type != 'videoAnno' && element.customData?.generationData?.type != 'audioAnno' && element.customData?.generationData?.type != 'cardAnno') &&
                <Popover trigger={"click"} placement={"bottom"}
                         arrow={false}
                         align={{offset: [0, ELEMENT_POPOVER_TOOLS_OFFSET_Y]}}
                         open={isBackgroundPopover}
                         onOpenChange={(e) => setIsBackgroundPopover(e)}
                         content={
                             renderAction("changeBackgroundColorPopover")}>
                    <Tooltip title={t("Color")} arrow={false}>
                    <div className={style.toolbarItem + ' hovered'}
                         style={{background: isBackgroundPopover ? COLOR_E5E5E5() : COLOR_TRANSPARENT,flexShrink:'0',width:'32px',height:'32px'}}>
                        {
                            renderBackgroundColor()
                        }
                    </div>
                    </Tooltip>
                </Popover>
            }

            {
                targetElements.some((element)=>isBookmarkElement(element)) &&
                <Popover trigger={"click"} placement={"bottom"}
                         arrow={false}
                         align={{offset: [0, ELEMENT_POPOVER_TOOLS_OFFSET_Y]}}
                         open={isStrokeColorPopover}
                         onOpenChange={(e) => setIsStrokeColorPopover(e)}
                         content={renderAction("changeStrokeColorPopover")}>
                    <div className={style.toolbarItem}
                         style={{background: isStrokeColorPopover ? COLOR_E5E5E5() : COLOR_TRANSPARENT}}>
                        <img className='img-28 hovered bookmark-element' style={{flexShrink: '0', width: '30px', height: '30px'}}
                             src={getImagePathWithTheme('toolbar_element_background_new')}/>
                    </div>
                </Popover>
            }

            {
                //背景2 线条和箭头使用的，实际不是背景--
                // targetElements.some((element) => element.type=='arrow' || element.type == 'line' || element.type == 'freedraw') &&
                // <Popover trigger={"click"} placement={"bottom"}
                //          arrow={false}
                //          align={{offset: [0, ELEMENT_POPOVER_TOOLS_OFFSET_Y]}}
                //          open={isBackgroundPopover}
                //          onOpenChange={(e) => setIsBackgroundPopover(e)}
                //          content={
                //              renderAction("changeStrokeColorPopover")}>
                //     <div className={style.toolbarItem + ' hovered'}
                //          style={{background: isBackgroundPopover ? COLOR_E5E5E5() : COLOR_TRANSPARENT,flexShrink:'0',width:'32px',height:'32px'}}>
                //         {
                //             <img className='img-28 hovered' style={{flexShrink: '0', width: '30px', height: '30px'}}
                //                  src={imgPathPerfix() + 'toolbar_element_background_new.png'}/>
                //         }
                //     </div>
                // </Popover>
            }

            {/****stroke颜色*/}
            {
                // (targetElements.some((element) => hasStrokeColor(element)) && !isActiveToolDrawing()) &&
                // <Popover trigger={"click"} placement={"bottom"}
                //          arrow={false}
                //          align={{offset: [0, ELEMENT_POPOVER_TOOLS_OFFSET_Y]}}
                //          open={isStrokeColorPopover}
                //          onOpenChange={(e) => setIsStrokeColorPopover(e)}
                //          content={renderAction("changeStrokeColorPopover")}>
                //     <div className={style.toolbarItem}
                //          style={{background: isStrokeColorPopover ? COLOR_E5E5E5() : COLOR_TRANSPARENT}}>
                //         <span className={'flex-center'} style={{width: '30px', height: '30px'}}>
                //             <span
                //                 style={{
                //                     width: '21px',
                //                     height: '21px',
                //                     border: '4px solid ' + strokeColor,
                //                     borderRadius: '4px'
                //                 }}></span>
                //         </span>
                //
                //     </div>
                // </Popover>
            }

            {/***drawfree--stroke颜色 */}
            {
                // isActiveToolDrawing() &&
                // <Popover trigger={"click"} placement={"bottom"}
                //          arrow={false}
                //          open={isStrokeColorPopover}
                //          align={{offset: [0, ELEMENT_POPOVER_TOOLS_OFFSET_Y]}}
                //          onOpenChange={(e) => setIsStrokeColorPopover(e)}
                //          content={
                //              renderAction("changeDrawStrokeColorPopover")}>
                //     <div className={style.toolbarItem}
                //          style={{
                //              background: isStrokeColorPopover ? COLOR_E5E5E5() : COLOR_TRANSPARENT,
                //              padding: '6px'
                //          }}>
                //         <div className='img-20'
                //              style={{
                //                  width:'20px',height:'20px',
                //                  border: '4px solid ' + getFreedrawStrokeColor(),
                //                  borderRadius: '4px'
                //              }}></div>
                //     </div>
                // </Popover>
            }

            {
                //边框样式...
                // (targetElements.some((element) => hasStrokeStyle(element)) && !isActiveToolDrawing()) &&
                // <Popover trigger={"click"} placement={"bottom"}
                //          arrow={false}
                //          align={{offset: [0, ELEMENT_POPOVER_TOOLS_OFFSET_Y]}}
                //          open={isLineStylePopover}
                //          onOpenChange={(e) => setIsLineStylePopover(e)}
                //          content={
                //              <div className={'popover-box-shadow'} style={{
                //                  margin: '-12px',
                //                  width: '256px',
                //                  height: 'auto',
                //                  padding: '2px 12px 12px 12px'
                //              }}>
                //                  <div className='mt-12'>
                //                      {
                //                          !(targetElements.some((element) => isFreeDrawElement(element))) &&
                //                          renderAction("changeStrokeStyleHorizontal")
                //                      }
                //                  </div>
                //                  <div className='mt-22'>
                //                      {renderAction("changeStrokeWidthToolbar")}
                //                  </div>
                //                  {
                //                      targetElements.some((element) => element.type == 'rectangle' || element.type == 'roundedRectangle' || element.type == 'iframe' || element.type == 'image') &&
                //                      <div className='mt-12'>
                //                          {renderAction("changeCornerWidthToolbar")}
                //                      </div>
                //                  }
                //              </div>
                //          }>
                //     <div className={style.toolbarItem}
                //          style={{background: isLineStylePopover ? COLOR_E5E5E5() : COLOR_TRANSPARENT}}>
                //         <img className='img-30' src={getImagePathWithTheme('tool_stroke_style')}/>
                //     </div>
                // </Popover>
            }

            {
                // hasStyleAfterVLine() &&
                // <div datatype={'mul-element'} className={'line-split-width1'}></div>
            }


            {
                //绘制工具显示的边框...
                // (isActiveToolDrawing()) &&
                // <Popover trigger={"click"} placement={"bottom"}
                //          arrow={false}
                //          align={{offset: [0, ELEMENT_POPOVER_TOOLS_OFFSET_Y]}}
                //          open={isDrawingPopover}
                //          onOpenChange={(e) => setIsDrawingPopover(e)}
                //          content={
                //              <div style={{
                //                  margin: '-12px',
                //                  width: '256px',
                //                  height: 'auto',
                //                  padding: '2px 12px 12px 12px'
                //              }}>
                //                  <div className='mt-12'>
                //                      {renderAction("changeStrokeWidthWithDrawingToolbar")}
                //                  </div>
                //                  <div className='mt-22'>
                //                      {renderAction("changeOpacyColorWithDrawingToolbar")}
                //                  </div>
                //              </div>
                //          }>
                //     <div className={style.toolbarItem}
                //          style={{background: isLineStylePopover ? COLOR_E5E5E5() : COLOR_TRANSPARENT}}>
                //         <img className='img-30' src={getImagePathWithTheme('tool_stroke_style')}/>
                //     </div>
                // </Popover>
            }

            {/****文字属性*/}
            {
                (appState.activeTool.type === "text" ||
                    targetElements.some(p => isTextElement(p) || isStickyNotesElement(p))) && (
                    <>
                        {
                            targetElements.some(p=>!p.containerId && !isShapeElement(p) && !isArrowElement(p)) &&
                            <>
                                <Tooltip title={<div className={'flex-column-center'}>
                                    <span>{t("Open in popup")}</span><span>{isMac() ? t("CmdCtrlToOpenInFloatingWindow").replace("Ctrl", "Cmd") : t("CmdCtrlToOpenInFloatingWindow")}</span>
                                </div>} arrow={false}>
                                    <div className={style.toolbarItem + ' hovered'}
                                         style={{
                                             background: COLOR_TRANSPARENT,
                                             flexShrink: '0',
                                             width: '32px',
                                             height: '32px'
                                         }} onClick={(event)=>{
                                        let isCtrl = event.ctrlKey || event.metaKey;
                                        Global.g_isCtrlPressed = isCtrl;
                                             //打开编辑...
                                        const arraySelectedElements = getSelectedElements(elements, appState);
                                        if (arraySelectedElements?.length > 0){
                                            window.showDialogTiptapTextEditorView(arraySelectedElements[0]);
                                        }
                                        setTimeout(()=>{
                                            Global.g_isCtrlPressed = false;
                                        },2000);
                                    }}>
                                        <img className='img-28 hovered renderbackgroundcolor-toolbar-menu'
                                             style={{flexShrink: '0', width: '30px', height: '30px'}}
                                             src={getImagePathWithTheme('toolbar_element_openin_dialog.svg')}/>
                                    </div>
                                </Tooltip>
                                <div className={'line-split-width1'}></div>
                            </>
                        }


                        {
                            //只有矩形中间的文字才有
                            targetElements.some(p => isBoundElementText(p)) &&
                            <div className={'line-split-width1'}></div>
                        }

                        {
                            //这里是富文本的stickynote显示的背景的位置---调整了位置需要启用的。
                            //背景----**************背景当stroke使用.....分不清...
                            targetElements.some((element) => isStickyNotesElement(element) || (isTextElement(element) && !element.containerId && HAS_ENABLE_TIPTAP_TEXT)) && stickyNotesSelectionLength == 0 &&
                            <>
                                <Popover trigger={"click"} placement={"bottom"}
                                         arrow={false}
                                         align={{offset: [0, ELEMENT_POPOVER_TOOLS_OFFSET_Y]}}
                                         open={isBackgroundPopover}
                                         onOpenChange={(e) => setIsBackgroundPopover(e)}
                                         content={
                                             renderAction("changeBackgroundColorPopover")}>
                                    <Tooltip title={t("Color")} arrow={false}>
                                        <div className={style.toolbarItem + ' hovered'}
                                             style={{
                                                 background: isBackgroundPopover ? COLOR_E5E5E5() : COLOR_TRANSPARENT,
                                                 flexShrink: '0',
                                                 width: '32px',
                                                 height: '32px'
                                             }}>
                                            {
                                                renderBackgroundColor()
                                            }
                                        </div>
                                    </Tooltip>
                                </Popover>

                                {/*<div className={'line-split-width1'}></div>*/}
                            </>
                        }

                        {
                            targetElements.every(p => (isTextElement(p) && !p.containerId) || isStickyNotesElement(p)) &&
                            //继续加.....
                            //文本边框
                            //文本元素  边框
                            <Tooltip key={randomTextBorderKey}
                                     title={t(targetElements[0].customData?.generationData?.isShowBorder ? 'Hide border' : 'Show border')}
                                     arrow={false}>
                                <div className={style.toolbarItem + ' hovered'}
                                     style={{
                                         background: COLOR_TRANSPARENT,
                                         flexShrink: '0',
                                         width: '32px',
                                         height: '32px'
                                     }}>
                                    <img className='img-30' src={getImagePathWithTheme('toolbar_element_border.svg')}
                                         onClick={(e) => {
                                             const isShowBorder = targetElements[0].customData.generationData?.isShowBorder || false;
                                             for (let i = 0; i < targetElements.length; i++) {
                                                 const customData = {...targetElements[i].customData};
                                                 customData.generationData.isShowBorder = !isShowBorder;
                                                 mutateElement(targetElements[i], {customData});
                                                 setRandomTextBorderKey(generateUUID2());
                                                 localStorage.setItem(isStickyNotesElement(targetElements[i]) ? KEY_STICKYNOTES_HAS_BORDER : KEY_TEXT_HAS_BORDER, isShowBorder ? 'false' : 'true')
                                             }
                                         }}/>
                                </div>
                            </Tooltip>
                        }

                        <Tooltip title={t("Font")} arrow={false}>
                            <div className={style.fontFamilyContainer + ' ' + style.toolbarItem}>
                                {renderAction("changeFontFamily")}
                            </div>
                        </Tooltip>

                        <Tooltip title={t("Font size")} arrow={false}>
                            <div className={style.toolbarItem}>
                                {renderAction("changeFontSize")}
                            </div>
                        </Tooltip>

                        <div className={'line-split-width1'}></div>

                        <Popover trigger={"click"} placement={"bottom"}
                                 arrow={false}
                                 align={{offset: [0, ELEMENT_POPOVER_TOOLS_OFFSET_Y]}}
                                 open={isFontColorPopover}
                                 onOpenChange={(e) => {
                                     setIsFontColorPopover(e);
                                     // window?.onBindBlurEvent({isTargetPickerTigger:true});
                                 }}

                                 content={
                                     renderAction("changeFontStrokeColor")
                                 }>
                            <Tooltip title={t("Color")} arrow={false}>
                                <div className={style.toolbarItem}
                                     style={{
                                         width: '30px',
                                         height: '30px',
                                         background: isFontColorPopover ? 'var(--hover-background-color)' : COLOR_TRANSPARENT
                                     }}>
                                    <div
                                        className={'active-color'}
                                        style={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                            width: '30px', height: '30px'
                                        }}>
                                        {/*<span className='font-family-medium active-color'*/}
                                        {/*      style={{fontSize: '17px',fontWeight:'700', marginTop: '-1px',color:isDarkMode()?'#ABABAB':'#666666'}}>A</span>*/}
                                        {/*    <div className={'active-color'} style={{*/}
                                        {/*        width: '20px',*/}
                                        {/*        height: '3px',*/}
                                        {/*        marginTop: '-3px',*/}
                                        {/*        background: fontStrokeColor*/}
                                        {/*    }}></div>*/}
                                        <img className={'img-30 hovered'} onMouseDown={(e) => {
                                            e.preventDefault();
                                        }}
                                             src={getImagePathWithTheme('mindmap_layout_color.svg')}/>
                                    </div>
                                </div>
                            </Tooltip>

                        </Popover>

                        {
                            targetElements.some(p => isStickyNotesElement(p) || isBoundElementText(p)) &&
                            <div className={'line-split-width1'}></div>
                        }

                        {/*{*/}
                        {/*    isFontColorPopover &&*/}
                        {/*    <div style={{position:"absolute",zIndex:'11000',left:'40px',top:'40px'}}>*/}
                        {/*        {renderAction("changeFontStrokeColor")}*/}
                        {/*    </div>*/}
                        {/*}*/}


                        {/*<div className={style.toolbarItem}>*/}
                        {/*    {renderAction("changeFontColor")}*/}
                        {/*</div>*/}
                        {
                            (appState.editingElement || targetSelectedElements.some(p => p.type == 'text' || p.type == 'stickyNotes')) &&
                            <>
                                <Popover arrow={false} trigger={['click']} onOpenChange={(e) => {
                                    setIsTextStylePopover(e);
                                }} placement={'bottom'}
                                         overlayInnerStyle={{margin: '0', padding: '0 6px'}} align={{offset: [0, 10]}}
                                         content={
                                             <div className={'flex-row-vertical-center'}
                                                  style={{height: '38px', gap: '6px 0'}}>
                                                 <Tooltip title={t("Bold")} arrow={false}>
                                                     <div className={style.toolbarItem}>
                                                         {renderAction("changeTextBold")}
                                                     </div>
                                                 </Tooltip>
                                                 <Tooltip title={t("Italic")} arrow={false}>
                                                     <div id={'actiontoolbar-menu-----'} className={style.toolbarItem}>
                                                         {renderAction("changeTextItalic")}
                                                     </div>
                                                 </Tooltip>
                                                 {
                                                     targetElements.some(p => isStickyNotesElement(p) || !p.containerId) &&
                                                     <>
                                                         <Tooltip title={t("Underline")} arrow={false}>
                                                             <div className={style.toolbarItem}>
                                                                 {renderAction("changeTextUnderline")}
                                                             </div>
                                                         </Tooltip>
                                                         <Tooltip title={t("Throughout")} arrow={false}>
                                                             <div className={style.toolbarItem}>
                                                                 {renderAction("changeTextStrikeout")}
                                                             </div>
                                                         </Tooltip>
                                                     </>
                                                 }

                                             </div>}>
                                    <Tooltip arrow={false} title={i18next.t("Text style")}>
                                        <div
                                            style={{
                                                borderRadius: '8px',
                                                background: isTextStylePopover ? 'var(--hover-background-color)' : COLOR_TRANSPARENT
                                            }}>
                                            <img className={'img-30 cursor-pointer hovered'} onMouseDown={(e) => {
                                                e.stopPropagation();
                                                e.preventDefault();
                                            }}
                                                 src={getImagePathWithTheme('mindmap_toolbar_style', true)}/>
                                        </div>
                                    </Tooltip>
                                </Popover>

                                <div className={'line-split-width1'}></div>

                            </>
                        }


                        {
                            targetSelectedElements.some(p => p.type == 'text' || isStickyNotesElement(p)) &&
                            <Popover trigger={"click"} placement={"bottom"}
                                     arrow={false}
                                     content={
                                         renderAction('changeTextAlignPopover')
                                     }
                                     open={isAlignPopover}
                                     onOpenChange={(e) => setIsAlignPopover(e)}>
                                <Tooltip title={t("Align")} arrow={false}>
                                    <div className={style.toolbarItem}
                                         style={{background: isAlignPopover ? COLOR_E5E5E5() : COLOR_TRANSPARENT}}>
                                        <img className={'img-30'} src={getImagePathWithTheme(getTextAlignImg())}/>
                                    </div>
                                </Tooltip>
                            </Popover>
                        }

                        {
                            !HAS_ENABLE_TIPTAP_TEXT && targetSelectedElements.some(p => p.type == 'text') &&
                            <Popover trigger={"click"} placement={"bottom"}
                                     arrow={false}
                                     content={
                                         renderAction('changeLineHeight')
                                     }
                                     align={{offset: [0, ELEMENT_POPOVER_TOOLS_OFFSET_Y]}}
                                     overlayInnerStyle={{width: '260px', padding: '20px 20px 12px 20px'}}
                                     open={isLineSpacePopover}
                                     onOpenChange={(e) => setIsLineSpacePopover(e)}>
                                <Tooltip title={t("Line spacing")} arrow={false}>
                                    <div className={style.toolbarItem}
                                         style={{background: isLineSpacePopover ? COLOR_E5E5E5() : COLOR_TRANSPARENT}}>
                                        <img className={'img-30'} src={getImagePathWithTheme('tool_text_v_space.svg')}/>
                                    </div>
                                </Tooltip>
                            </Popover>
                        }


                        {
                            //这里是stickynote20250815之前的背景选择所在的位置....不一样。
                            //背景----**************背景当stroke使用.....分不清...
                            // targetElements.some((element) => isStickyNotesElement(element)) &&  stickyNotesSelectionLength == 0 &&
                            // <>
                            //     <Popover trigger={"click"} placement={"bottom"}
                            //              arrow={false}
                            //              align={{offset: [0, ELEMENT_POPOVER_TOOLS_OFFSET_Y]}}
                            //              open={isBackgroundPopover}
                            //              onOpenChange={(e) => setIsBackgroundPopover(e)}
                            //              content={
                            //                  renderAction("changeBackgroundColorPopover")}>
                            //         <Tooltip title={t("Color")} arrow={false}>
                            //             <div className={style.toolbarItem + ' hovered'}
                            //                  style={{
                            //                      background: isBackgroundPopover ? COLOR_E5E5E5() : COLOR_TRANSPARENT,
                            //                      flexShrink: '0',
                            //                      width: '32px',
                            //                      height: '32px'
                            //                  }}>
                            //                 {
                            //                     renderBackgroundColor()
                            //                 }
                            //             </div>
                            //         </Tooltip>
                            //     </Popover>
                            // </>
                        }

                    </>
                )
            }

            {/*mindmap*/}
            {/*{(targetMindmapNode?.isRoot ||*/}
            {/*    (targetElements.length === 1 &&*/}
            {/*        (appState.activeTool.type === "mindmap" ||*/}
            {/*            commonSelectedType === "mindmap"))) && (*/}
            {/*    <>{renderAction("changeMindmapLayout")}</>*/}
            {/*)}*/}

            {/*{targetMindmapNode && (*/}
            {/*    <>*/}
            {/*        <div style={{width: '16px'}}></div>*/}
            {/*        {renderAction("changeLineStyle")}*/}
            {/*        <div style={{width: '16px'}}></div>*/}
            {/*        {renderAction("changeNodeStyle")}*/}
            {/*    </>*/}
            {/*)}*/}

            {/*位置*/}
            {/*{*/}
            {/*    (!isActiveToolDrawing()) &&*/}
            {/*    <>*/}
            {/*        {*/}
            {/*            (!hasPositionInFirst()) &&*/}
            {/*            <div datatype={'positionBefore'} style={{width: '1px', height: '24px', background: 'var(--vertical-line-color)'}}></div>*/}
            {/*        }*/}

            {/*        <Popover trigger={"click"} placement={"bottom"}*/}
            {/*                 arrow={false}*/}
            {/*                 align={{offset:[0,15]}}*/}
            {/*                 open={isPositionPopover}*/}
            {/*                 onOpenChange={(e)=>setIsPositionPopover(e)}*/}
            {/*                 content={*/}
            {/*            <div className={style.popoverPositon + ' font-size-12'}*/}
            {/*                 style={{width: '254px', height: '122px', padding: '12px 12px 10px 22px', margin: '-12px'}}>*/}
            {/*                <div>*/}
            {/*                    {renderAction("changePosition")}*/}
            {/*                </div>*/}
            {/*                <div>*/}
            {/*                    {renderAction("changeSize")}*/}
            {/*                </div>*/}
            {/*                <div>*/}
            {/*                    {renderAction("angleCorner")}*/}
            {/*                </div>*/}
            {/*            </div>*/}
            {/*        }>*/}
            {/*            <div className={style.toolbarItem} style={{margin: '0 18px 0 18px'}}>*/}
            {/*                <span>{t("Position")}</span>*/}
            {/*            </div>*/}
            {/*        </Popover>*/}
            {/*        <div datatype={'positionAfter'} style={{width: '1px', height: '24px', background: 'var(--vertical-line-color)', marginRight: '12px'}}></div>*/}
            {/*    </>*/}
            {/*}*/}


            {/****透明度*/}
            {/*{*/}
            {/*    (!isActiveToolDrawing()) &&*/}
            {/*    <div className={style.toolbarItem}>*/}
            {/*        {renderAction("changeOpacityPopover")}*/}
            {/*    </div>*/}
            {/*}*/}

            {/******锁*/}
            {/*{*/}
            {/*    (!isActiveToolDrawing()) &&*/}
            {/*    <img className={style.toolbarItem + ' img-30'} src={getImagePathWithTheme(getElementLockImage())}*/}
            {/*         onClick={() => {*/}
            {/*             const element = getFirstSelectElment();*/}
            {/*             if (element) {*/}
            {/*                 if (element.locked) {*/}
            {/*                     app.executeContextMenuAction("toggleElementLock")*/}
            {/*                 } else {*/}
            {/*                     app.executeContextMenuAction("toggleElementLock")*/}
            {/*                 }*/}
            {/*                 postMessage(EVENT_TOOLBAR_LOCKED_CHANGED, {locked: !element.locked})*/}
            {/*             }*/}
            {/*         }}/>*/}
            {/*}*/}

            {/*{targetElements.length > 1 && !isSingleElementBoundContainer && (*/}
            {/*    <div className={style.toolbarItem + ' ' + style.alignItem + (isDarkMode()?" filter-all-img-white":"")}>*/}
            {/*        <span className='mr-6'>{t("Align")}</span>*/}
            {/*        {renderAction("alignLeft")}*/}
            {/*        {renderAction("alignHorizontallyCentered")}*/}
            {/*        {renderAction("alignRight")}*/}
            {/*        {targetElements.length > 2 &&*/}
            {/*            renderAction("distributeHorizontally")}*/}
            {/*        {renderAction("alignTop")}*/}
            {/*        {renderAction("alignVerticallyCentered")}*/}
            {/*        {renderAction("alignBottom")}*/}
            {/*        {targetElements.length > 2 &&*/}
            {/*            renderAction("distributeVertically")}*/}
            {/*    </div>*/}
            {/*)}*/}

        </div>
    )
}





































